import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { liveBettingRouteI18n } from '../i18n/live-betting-route-i18n';

export function liveBettingRoutePath(config?: TranslationConfig): string {
  return `/${langRouteI18n(config)}/${liveBettingRouteI18n(config)}`;
}
